import _ from 'lodash';
import moment from 'moment';
import DateHelper from '../../utilities/DateHelper';
import LadderLocalStorage from '../../utilities/LadderLocalStorage';
import {
	ADD_BANK_TRANSACTION_AS_TRANSACTION_CANCELLED,
	ADD_BANK_TRANSACTION_AS_TRANSACTION_SUCCESS,
	BUDGET_SUB_TAB_CHANGED,
	CHANGE_BUDGET_LIST_MODE,
	CONNECTION_OFFLINE,
	CONNECTION_ONLINE,
	CREATED_ACCOUNT,
	DELETE_ALL_TRANSACTIONS_BEGIN,
	DELETE_ALL_TRANSACTIONS_FAIL,
	DELETE_ALL_TRANSACTIONS_POPUP_HIDE,
	DELETE_ALL_TRANSACTIONS_POPUP_SHOW,
	DELETE_ALL_TRANSACTIONS_SUCCESS,
	END_TRANSACTION_EDIT_MODE,
	HIDE_ONLY_UNCATEGORIZED_TRANSACTIONS,
	HIGHLIGHTED_CATEGORY,
	HIGHLIGHTED_TRANSACTION,
	LAST_EDITED_TRANSACTION_CHANGED,
	LOGOUT_BEGIN,
	REPLACE_PREVIOUS_TRANSACTION,
	SAVE_ALL_CHANGED_BUDGETS_FOR_CATEGORY_GROUP_BEGIN,
	SAVE_ALL_CHANGED_BUDGETS_FOR_CATEGORY_GROUP_ERROR,
	SAVE_ALL_CHANGED_BUDGETS_FOR_CATEGORY_GROUP_SUCCESS,
	SET_CATEGORY_AS_SUBGROUP_MODE_ACTIVE,
	SET_PLAYER, SHOW_ONLY_UNCATEGORIZED_TRANSACTIONS,
	START_TRANSACTION_EDIT_MODE,
	SUBMIT_CATEGORY_BUDGET_UPDATE_BEGIN,
	SUBMIT_CATEGORY_BUDGET_UPDATE_ERROR,
	SUBMIT_CATEGORY_BUDGET_UPDATE_SUCCESS,
	UN_HIGHLIGHTED_CATEGORY,
	UN_HIGHLIGHTED_TRANSACTION,
	UPDATE_BUDGETS_BEGIN,
	UPDATE_CATEGORY_GROUPS_BEGIN,
	UPDATE_REFRESH_FAIL,
	UPDATE_REFRESH_SUCCESS,
	UPDATE_SELECTED_DATE,
	UPDATE_TRANSACTIONS_BEGIN,
	updateTemporaryTransaction
} from '../actions/dashboard';
import { UPDATED_WINDOW_SIZE } from '../actions/windowSize';
import TransactionFinder from 'utilities/transactionFinder/TransactionFinder';
import BudgetListModes from "../../react/components/BudgetListModes";
import {
	RETRIEVE_PLAID_TRANSACTIONS_SUCCESS
} from "../actions/plaid.js";
import { ADD_CLONED_TRANSACTION, SET_CATEGORY_AS_SUBGROUP_MODE_DEACTIVE } from "../actions/dashboard.js";
import { CHANGE_ACTIVE_BUDGET_SUCCESS } from "../actions/sharing.js";

const date = moment();
const defaultSelectedDates = {
	[DateHelper.yearMonthSerialize(date)]: null,
};

let selectedDates = LadderLocalStorage.getItem('selectedDates', defaultSelectedDates);
let selectedDate = null;
if(_.size(selectedDates) === 0) {
	selectedDates = defaultSelectedDates;
}

_.each(selectedDates, (value, key) => {
	const [year, month] = key.split('-');
	const date = moment().year(year).month(month);
	selectedDates[key] = date;
	selectedDate = date;
});
if(_.size(selectedDates) > 1) {
	selectedDate = null;
}

const initialState = {
	selectedDate: selectedDate,
	selectedDates: selectedDates,
	visibleDates: [],
	player: undefined,
	isOnline: navigator.onLine,
	selectedMainTab: null,

	firstLoad: true,
	refreshingData: false,
	loadPosition: null,
	replacedTransaction: null,

	transactionFinder: new TransactionFinder(),

	deleteAllTransactionsPopup: false,
	transactions: null,
	categories: null,
	categoryGroups: null,
	budgets: null,
	lastEditedTransactionId: null,
	editBudgetListMode: LadderLocalStorage.getItem('editBudgetListMode', BudgetListModes.DASHBOARD),
	submittingBudgets: {},
	submittingBudgetsForCategoryGroup: {},

	highlightedCategory: null,
	highlightedTransaction: null,
	transactionBeingEdited: null,
	transactionFinderUpdates: null,

	showOnlyUncategorizedTransactions: false,

	transactionBeingEditedModalShouldBeOpen: false,

	lastChangedBudget: null,

	setCategoryAsSubgroupCategory: null,

};
window.transactionFinder = initialState.transactionFinder;
const loadPositions = 4;

function isCurrentlySelectedId(field, modelId) {
	let isCurrent = false;
	if(modelId) {
		isCurrent = field === modelId;
	}
	return isCurrent;
}

export default (state = initialState, action) => {
	switch(action.type) {
		case SHOW_ONLY_UNCATEGORIZED_TRANSACTIONS:
			return {
				...state,
				showOnlyUncategorizedTransactions: true
			}
		case HIDE_ONLY_UNCATEGORIZED_TRANSACTIONS:
			return {
				...state,
				showOnlyUncategorizedTransactions: false
			}
		case CHANGE_ACTIVE_BUDGET_SUCCESS: {
			const player = { ...state.player };
			player.active_budget = action.payload.active_budget;
			console.log('what is player bnow', player, action.payload);
			return {
				...state,
				player
			};
		}
		case RETRIEVE_PLAID_TRANSACTIONS_SUCCESS: {
			return {
				...state,
				transactionFinderUpdates: state.transactionFinder.updates,
			};
		}
		case HIGHLIGHTED_CATEGORY: {
			return {
				...state,
				highlightedCategory: action.payload.id,
			};
		}
		case HIGHLIGHTED_TRANSACTION: {
			return {
				...state,
				highlightedTransaction: action.payload.id
			};
		}
		case UN_HIGHLIGHTED_CATEGORY: {
			//Will only remove highlight if it's the current active highlight
			let setTo = action.payload ? action.payload.id : null;
			if(isCurrentlySelectedId(state.highlightedCategory, setTo)) {
				setTo = null;
			}
			return {
				...state,
				highlightedCategory: setTo
			};
		}
		case UN_HIGHLIGHTED_TRANSACTION: {
			//Will only remove highlight if it's the current active highlight
			let setTo = action.payload ? action.payload.id : null;
			if(isCurrentlySelectedId(state.highlightedTransaction, setTo)) {
				setTo = null;
			}
			return {
				...state,
				highlightedTransaction: setTo
			};
		}
		case SAVE_ALL_CHANGED_BUDGETS_FOR_CATEGORY_GROUP_BEGIN: {
			const submittingBudgetsForCategoryGroup = { ...state.submittingBudgetsForCategoryGroup };
			submittingBudgetsForCategoryGroup[action.payload] = true;
			return {
				...state,
				submittingBudgetsForCategoryGroup
			};
		}
		case SAVE_ALL_CHANGED_BUDGETS_FOR_CATEGORY_GROUP_ERROR:
		case SAVE_ALL_CHANGED_BUDGETS_FOR_CATEGORY_GROUP_SUCCESS: {
			const submittingBudgetsForCategoryGroup = { ...state.submittingBudgetsForCategoryGroup };
			delete submittingBudgetsForCategoryGroup[action.payload];
			return {
				...state,
				submittingBudgetsForCategoryGroup,
			};
		}
		case SUBMIT_CATEGORY_BUDGET_UPDATE_BEGIN: {
			const submittingBudgets = { ...state.submittingBudgets };
			submittingBudgets[action.payload.categoryId] = true;
			return {
				...state,
				submittingBudgets,
				lastChangedBudget: action.payload.updatedBudget,
			};
		}
		case SUBMIT_CATEGORY_BUDGET_UPDATE_SUCCESS:
		case SUBMIT_CATEGORY_BUDGET_UPDATE_ERROR: {
			const submittingBudgets = { ...state.submittingBudgets };
			delete submittingBudgets[action.payload];
			return {
				...state,
				submittingBudgets,
			};
		}
		case LAST_EDITED_TRANSACTION_CHANGED: {
			return {
				...state,
				lastEditedTransactionId: action.payload
			};
		}
		case START_TRANSACTION_EDIT_MODE: {
			const { transaction, options } = action.payload;
			return {
				...state,
				transactionBeingEdited: transaction,
				transactionBeingEditedModalShouldBeOpen: true,
				transactionBeingEditedCategoryLocked: !!options.addingForSpecificCategory,
			};
		}
		case END_TRANSACTION_EDIT_MODE: {
			return {
				...state,
				transactionBeingEdited: null,
				transactionBeingEditedModalShouldBeOpen: false,
				transactionBeingEditedCategoryLocked: false,
			};
		}
		case ADD_BANK_TRANSACTION_AS_TRANSACTION_CANCELLED: {
			const payload = action.payload;
			const transactionFinder = state.transactionFinder;
			transactionFinder.getAllTransactions()
				.filter((transaction) => {
					if(transaction.plaid_transaction_id === payload.plaid_transaction_id && !transaction.id && !transaction.submitting) {
						console.log('removing', transaction);
						transactionFinder.removeTransaction(transaction);
						return false;
					}
					return true;
				});
			return {
				...state,
				// transactions: transactionFinder.getAllTransactions(),
				transactionFinderUpdates: transactionFinder.updates,
			};
		}
		case REPLACE_PREVIOUS_TRANSACTION: {
			const transactionFinder = state.transactionFinder;
			const { newTransaction, old, keepSubmitId } = action.payload;

			transactionFinder.removeTransaction(old);
			if(!keepSubmitId) {
				newTransaction.submit_id = null;
			}
			console.log('replacing', old, 'with', newTransaction);
			transactionFinder.addTransaction(newTransaction);
			return {
				...state,
				// transactions: transactionFinder.getAllTransactions(),
				transactionFinderUpdates: transactionFinder.updates,
				replacedTransaction: old?.beforeChanges,
			};
		}
		case ADD_BANK_TRANSACTION_AS_TRANSACTION_SUCCESS: {
			return {
				...state,
				transactionBeingEdited: action.payload,
				transactionBeingEditedModalShouldBeOpen: true,
			};
		}
		case ADD_CLONED_TRANSACTION: {
			const transactionFinder = state.transactionFinder;
			console.log('normal transcctiopns', action.payload);
			transactionFinder.addTransaction(action.payload);
			return {
				...state,
				// transactions: transactionFinder.getAllTransactions(),
				transactionFinderUpdates: transactionFinder.updates,
				transactionBeingEditedModalShouldBeOpen: false,
			};
		}
		case UPDATE_CATEGORY_GROUPS_BEGIN: {
			return {
				...state,
				loadPosition: 1 / loadPositions,
				refreshingData: true
			};
		}
		case UPDATE_TRANSACTIONS_BEGIN: {
			return {
				...state,
				loadPosition: 2 / loadPositions,
			};
		}
		case UPDATE_BUDGETS_BEGIN: {
			return {
				...state,
				loadPosition: 3 / loadPositions,
			};
		}
		case UPDATE_REFRESH_SUCCESS: {
			const refreshedState = {
				...state,
				loadPosition: 4 / loadPositions,
				refreshingData: false,
				firstLoad: false,
				...action.payload,
			};
			const visibleDates = getVisibleDates(refreshedState, refreshedState);
			return {
				...refreshedState,
				visibleDates,
			};
		}
		case UPDATE_REFRESH_FAIL: {
			return {
				...state,
				refreshingData: false,
				firstLoad: false,
			};
		}
		case DELETE_ALL_TRANSACTIONS_POPUP_SHOW: {
			return {
				...state,
				deleteAllTransactionsPopup: true
			};
		}
		case DELETE_ALL_TRANSACTIONS_POPUP_HIDE: {
			return {
				...state,
				deleteAllTransactionsPopup: false,
			};
		}
		case DELETE_ALL_TRANSACTIONS_SUCCESS: {
			return {
				...state,
				deletingAllTransactionsForAMonth: true,
				deleteAllTransactionsPopup: false,
			};

		}
		case DELETE_ALL_TRANSACTIONS_FAIL: {
			return {
				...state,
				deletingAllTransactionsForAMonth: false,
				deleteAllTransactionsPopup: false,
			};
		}
		case DELETE_ALL_TRANSACTIONS_BEGIN: {
			return {
				...state,
				deletingAllTransactionsForAMonth: false,
				deleteAllTransactionsPopup: false,
			};

		}
		case CONNECTION_ONLINE: {
			return {
				...state,
				isOnline: true
			};
		}
		case CONNECTION_OFFLINE: {
			return {
				...state,
				isOnline: false
			};
		}
		case LOGOUT_BEGIN: {
			return {
				...state,
				player: undefined,
			};
		}
		case CHANGE_BUDGET_LIST_MODE: {
			LadderLocalStorage.setItem('editBudgetListMode', action.payload);
			return {
				...state,
				editBudgetListMode: action.payload,
			};
		}
		case SET_PLAYER: {
			return {
				...state,
				player: action.payload
			};
		}
		case UPDATED_WINDOW_SIZE: {

			return {
				...state,
				// visibleDates
			};
		}
		case UPDATE_SELECTED_DATE: {
			const selectedDates = action.payload.selectedDates;
			let selectedDate = null;
			const numberOfDatesSelected = _.size(selectedDates);
			if(numberOfDatesSelected === 1) {
				_.each(selectedDates, (date) => {
					selectedDate = date;
				});
			}
			const visibleDates = getVisibleDates(state, {
				selectedDate,
				selectedDates,
			});
			return {
				...state,
				selectedDate,
				selectedDates,
				visibleDates
			};
		}
		case SET_CATEGORY_AS_SUBGROUP_MODE_ACTIVE: {
			return {
				...state,
				setCategoryAsSubgroupCategory: action.payload,
			};
		}
		case SET_CATEGORY_AS_SUBGROUP_MODE_DEACTIVE: {
			return {
				...state,
				setCategoryAsSubgroupCategory: null,
			};
		}
		default: {
			return state;
		}
	}
};

const getVisibleDates = (dashboardState, dateState) => {
	const { budgets } = dashboardState;
	const { selectedDates } = dateState;

	const numberOfDatesSelected = _.size(selectedDates);
	if(numberOfDatesSelected === 0) {
		return [];
	}
	const newVisibleDates = [];

	const allDatesToUse = {};

	const monthFormat = 'YYYYMM';

	const addDateToAllDatesToUse = (date) => {
		date = date.clone().startOf('month');
		allDatesToUse[date.format(monthFormat)] = date;
	};

	let sortedDates = [];
	if(budgets) {
		for(let budget of budgets) {
			addDateToAllDatesToUse(budget.date);
		}
		_.each(selectedDates, (date) => {
			addDateToAllDatesToUse(date);
		});
		let allDates = [];
		_.each(allDatesToUse, (date) => {
			allDates.push(date);
		});
		sortedDates = _.orderBy(allDates, (date) => {
			return date.format(monthFormat);
		}, ['asc']);
	}

	let first = null;
	let last = null;
	_.each(sortedDates, (date) => {
		if(!first) {
			first = date;
		}
		if(!last) {
			last = date;
		}
		if(first.isAfter(date)) {
			first = date;
		}
		if(last.isBefore(date)) {
			last = date;
		}
	});
	if(!first) {
		return [];
	}

	let amountToUse = sortedDates.length;
	if(amountToUse < 12) {
		amountToUse = 12;
	}
	for(let monthOffset = (amountToUse * -1) + 1; monthOffset < amountToUse; monthOffset++) {
		if(monthOffset === 0) {
			let lastDate = null;
			_.each(sortedDates, (date) => {
				if(lastDate) {
					for(let betweenOffset = 1; betweenOffset < date.diff(lastDate, 'months'); betweenOffset++) {
						newVisibleDates.push(lastDate.clone().add(betweenOffset, 'months'));
					}
				}
				newVisibleDates.push(date);
				lastDate = date;
			});
			continue;
		}
		if(monthOffset < 0) {
			newVisibleDates.push(first.clone().startOf('month').add(monthOffset, 'months'));
		}
		if(monthOffset > 0) {
			newVisibleDates.push(last.clone().startOf('month').add(monthOffset, 'months'));
		}
	}
	return newVisibleDates;
};


